export function questionTableCellChange(payload) {
  return {
    type: "QUESTION_TABLE_CELL_CHANGE",
    payload,
  };
}

export function questionTableSubmit(payload) {
  return {
    type: "QUESTION_TABLE_SUBMIT",
    payload,
  };
}

export function questionTableShowHint(payload) {
  return {
    type: "QUESTION_TABLE_SHOW_HINT",
    payload,
  };
}

export function questionTableShowNextHint(payload) {
  return {
    type: "QUESTION_TABLE_SHOW_NEXT_HINT",
    payload,
  };
}
